(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  class SpotoBuyReminder extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.productSection = this.closest('.shopify-section');
      this.purchaseArea = this.productSection?.querySelector('.product-form-buttons');
      this.action = this.querySelector('[data-spoto-buy-reminder-action]');

      if (!this.productSection || !this.purchaseArea || !this.action) {
        this.remove();
        return;
      }

      const selector = 'spoto-buy-reminder[data-section-id="' + this.dataset.sectionId + '"]';
      const existingReminder = document.body.querySelector(selector);

      if (existingReminder && existingReminder !== this) {
        existingReminder.remove();
      }

      document.body.appendChild(this);

      this.getPurchaseButton = () =>
        this.productSection.querySelector('.add-to-cart-button:not([disabled])');

      this.handleAction = () => {
        const purchaseButton = this.getPurchaseButton();

        if (purchaseButton instanceof HTMLButtonElement) {
          if (this.action.id) {
            purchaseButton.dataset.spotoFlySource = this.action.id;
          }
          purchaseButton.click();
          return;
        }

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.purchaseArea.scrollIntoView({
          behavior: reducedMotion ? 'auto' : 'smooth',
          block: 'center',
        });
      };

      this.action.addEventListener('click', this.handleAction);

      this.observer = new IntersectionObserver(
        ([entry]) => {
          const canAddToCart = this.getPurchaseButton() instanceof HTMLButtonElement;
          const visible = canAddToCart && !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          this.dataset.visible = visible ? 'true' : 'false';
          this.setAttribute('aria-hidden', visible ? 'false' : 'true');
          this.toggleAttribute('inert', !visible);
        },
        { threshold: 0 }
      );

      this.observer.observe(this.purchaseArea);
    }

    disconnectedCallback() {
      this.observer?.disconnect();

      if (this.action && this.handleAction) {
        this.action.removeEventListener('click', this.handleAction);
      }
    }
  }

  if (!customElements.get('spoto-buy-reminder')) {
    customElements.define('spoto-buy-reminder', SpotoBuyReminder);
  }

  } catch(e) { console.error(e); }
})();
})();
